import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './services/auth.service';
import { DataService } from './services/data.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private dataService: DataService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Aquí imprimes información relevante
    console.log('Auth.services ejecutándose...');

    const token = localStorage.getItem('token');

    if (!token) {
      this.router.navigate(['/pages/login']);
      return false;
    }

    //  Token expirado → limpiar sesión y redirigir
    if (this.dataService.isTokenExpired(token)) {
      localStorage.clear();
      this.router.navigate(['/pages/login']);
      return false;
    }

    if (this.authService.hasPerms(state.url)) {
      // Aquí imprimes información relevante
      console.log('Auth.services ejecutándose...');
      console.warn('Acceso denegado! Redirigiendo...');
      return true;
    }
    // Aquí imprimes información relevante
    console.log('Auth.services ejecutándose...');
    console.warn('Acceso denegado! Redirigiendo...');
    return false;
  }
}
